export const usePaymentOption = () => {
  const PIX = 'pix';
  const CREDITCARD = 'credit_card';
  const FREE = 'free';
  return { PIX, CREDITCARD, FREE };
};
